import type { Filters } from '~~/types/filters.d.ts'

export const filtersToQuery = (filters: Filters, query) => {
  let transformedQuery = query

  if (filters.search) {
    transformedQuery = transformedQuery.textSearch(
      filters.searchReferences,
      `${filters.search.replace(/ /g, '+')}:*`,
    )
  }

  if (filters.limit) transformedQuery = transformedQuery.limit(filters.limit)

  if (filters.categories?.value?.length) {
    const conditions = filters.categories.value
      .map(value => {
        const field = filters.categories?.referencedColumn
        return `${field}.eq.${value}`
      })
      .join(',')
    transformedQuery = transformedQuery.or(
      conditions,
      filters.categories.referencedTable
        ? {
            referencedTable: filters.categories.referencedTable,
          }
        : {},
    )
  }

  if (filters.destinations?.value?.length) {
    const conditions = filters.destinations.value
      .map(value => {
        const field = filters.destinations?.referencedColumn
        return `${field}.eq.${value}`
      })
      .join(',')
    transformedQuery = transformedQuery.or(
      conditions,
      filters.destinations.referencedTable
        ? {
            referencedTable: filters.destinations.referencedTable,
          }
        : {},
    )
  }

  if (filters.countries?.value?.length) {
    const conditions = filters.countries.value
      .map(value => {
        const field = filters.countries?.referencedColumn
        return `${field}.ilike.${value}`
      })
      .join(',')
    transformedQuery = transformedQuery.or(
      conditions,
      filters.countries.referencedTable
        ? {
            referencedTable: filters.countries.referencedTable,
          }
        : {},
    )
  }

  transformedQuery = backSupportDepricatedFilters(filters, transformedQuery)
  return transformedQuery
}

function backSupportDepricatedFilters(filters: Filters, transformedQuery) {
  let supportDepricatedQuery = transformedQuery
  if (filters.country?.length) {
    supportDepricatedQuery = supportDepricatedQuery.or(
      filters.country
        .map((country: string) => `country.ilike.${country}`)
        .join(','),
      { referencedTable: 'spots.city' },
    )
  }

  if (filters.city?.length) {
    supportDepricatedQuery = supportDepricatedQuery.or(
      filters.city.map((city: string) => `name.ilike.${city}`).join(','),
      { referencedTable: 'spots.city' },
    )
  }

  if (filters.category?.length) {
    supportDepricatedQuery = supportDepricatedQuery.or(
      filters.category
        .map((category: string) => `name.ilike.${category}`)
        .join(','),
      { referencedTable: 'spots.category' },
    )
  }

  return supportDepricatedQuery
}
